require("./bootstrap");

require("alpinejs");

window.addEventListener("load", function () {
    init();
});

function init() {
    console.log("Loaded js");
    initSmartInputs();
    initTooltips();
}

window.initTooltips = () => {
    try {
        $(function () {
            $('[data-toggle="tooltip"]').tooltip();
        });
    } catch (error) { }
};

window.scrollToBottom = (selector) => {
    let chatWrapper = document.querySelector(selector);
    chatWrapper.scrollTo(0, chatWrapper.scrollHeight);
};

document.addEventListener("DOMContentLoaded", () => {
    Livewire.hook("component.initialized", (component) => { });
    Livewire.hook("element.initialized", (el, component) => { });
    Livewire.hook("element.updating", (fromEl, toEl, component) => { });
    Livewire.hook("element.updated", (el, component) => {
        document.querySelectorAll(".form-control").forEach((input) => {
            markIfFilled(input);
        });
    });
    Livewire.hook("element.removed", (el, component) => { });
    Livewire.hook("message.sent", (message, component) => { });
    Livewire.hook("message.failed", (message, component) => { });
    Livewire.hook("message.received", (message, component) => { });
    Livewire.hook("message.processed", (message, component) => { });
});

function initSmartInputs() {
    try {
        document.querySelectorAll(".form-control").forEach((input) => {
            input.addEventListener("change", function (e) {
                markIfFilled(e.target);
            });

            markIfFilled(input);
        });
    } catch (error) { }
}

window.markIfFilled = (inputField) => {
    try {
        if (inputField.classList.contains("bootstrap-select")) {
            inputField =
                inputField.querySelector(".selectpicker") || inputField;
        }

        value = inputField.value;

        if (!value) {
            inputField.classList.add("empty");
        } else {
            inputField.classList.remove("empty");
        }
    } catch (error) { }
};

window.realisticConfetti = function () {
    var count = 200;
    var defaults = {
        origin: { y: 0.7 }
    };

    function fire(particleRatio, opts) {
        window.confetti(Object.assign({}, defaults, opts, {
            particleCount: Math.floor(count * particleRatio)
        }));
    }

    fire(0.25, {
        spread: 26,
        startVelocity: 55,
    });
    fire(0.2, {
        spread: 60,
    });
    fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 0.8
    });
    fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.2
    });
    fire(0.1, {
        spread: 120,
        startVelocity: 45,
    });
}
